import * as React from 'react'
import {  useSelector } from 'react-redux'
import {  RootReducer } from "../../../components/app/reducer"
import { Link } from "react-router-dom"
import { CCB } from '../../../openapi/ccb'
import { RouteComponentProps } from "react-router" 

type RouteParams = {
    acctno: string
  }

type Props = RouteComponentProps<RouteParams> 

const CCBDetail: React.FC<Props> = ( props ) => {
    const acctno = props.match.params.acctno; 
    // all the data should be available in ccb search
    const ccbs = useSelector( (state:RootReducer) =>  state.ccbReducer.ccbs) || []
    const ccbToDisplay = ccbs.find((ccb:CCB) => ccb.acctno === acctno ) || {}

    return (
        
        <div id="ccb-detail">
            <p><Link to="/ccbresults">Back to List</Link></p>
            <p className="codelist-header"><span className="bold">Cash Correspondent Details</span></p>

            <div id="content">
                <div className="detail-pane">
                    <div className="detail-table">
                        {
                            [["Currency :", ccbToDisplay.curr], 
                            ["CBL Internal Currency Code :", ccbToDisplay.iccode],
                            ["Cash Correspondent Name :", ccbToDisplay.name],
                            ["Cash Correspondent City :", ccbToDisplay.city],
                            ["Cash Correspondent Country :", ccbToDisplay.ctry],
                            ["Clearstream Account Number / IBAN :", ccbToDisplay.acctno],
                            ["BIC :", ccbToDisplay.bic]
                            ].map( (rowData) => 
                                <div className="detail-table-row" key={rowData.join("|")}>
                                    <span className="detail-table-col-left" key={rowData[0]}>{rowData[0]}</span>
                                    <span className="detail-table-col-right" key={rowData[1]}>{rowData[1]}</span>
                                </div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    )
} 

export default CCBDetail
